module.exports = __webpack_public_path__ + "img/vet_basics_splash.b6f594ce.jpg";